/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { getUrls } from '../../../api/apiurls.js';
import { getStoreApi } from '../../../plugins/helper';
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux"; 
import citiesData from '../../json/cities.json'; 

import "react-datepicker/dist/react-datepicker.css";
import { bucketObj } from "../../../environment";
import axios from "axios";
import {
  createStore,
  updateStore,
} from "../../../api/settings.ts";
import {
    Info,
  } from "feather-icons-react/build/IconComponents";
import { useNavigate } from "react-router-dom";
import {uploadImageNew} from "../../../core/img/imagewithbasebath";


const AddStore = () => {
    let storeData = useSelector((state) => state.store_edit)
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");

    const [formDataList, setFormDataList] = useState({});
      
    
    const countriesData = 
    [
      { "value": "us", "label": "United States", "name": "United States" },
      { "value": "gb", "label": "England", "name": "England" },
      { "value": "jp", "label": "Japan", "name": "Japan" },
      { "value": "au", "label": "Australia", "name": "Australia" },
      { "value": "pk", "label": "Pakistan", "name": "Pakistan" },
      { "value": "jm", "label": "Jamaica", "name": "Jamaica" },
      { "value": "bs", "label": "Bahamas", "name": "Bahamas" },
      { "value": "dm", "label": "Dominica", "name": "Dominica" },
      { "value": "vc", "label": "Saint Vincent", "name": "Saint Vincent" },
      { "value": "lc", "label": "Saint Lucia", "name": "Saint Lucia" },
      { "value": "gy", "label": "Guyana", "name": "Guyana" }
    ];
  
  // [
//     { code: "pk", currency: "pkr" },
//     { code: "us", currency: "usd" },
//     { code: "gb", currency: "gbp" },
//     { code: "jp", currency: "jpy" },
//   ];
    // const [imageLoading] = useState(0)
    const countryOptions = countriesData;
    const [cities, setCities] = useState([]);
    const [btnLoading, setBtnLoading] = useState(false);
    //
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    const initialSchedule = {
      Sunday: { closed: false, openTime: "10:00", closeTime: "20:00" },
      Monday: { closed: false, openTime: "10:00", closeTime: "20:00" },
      Tuesday: { closed: false, openTime: "10:00", closeTime: "20:00" },
      Wednesday: { closed: false, openTime: "10:00", closeTime: "20:00" },
      Thursday: { closed: false, openTime: "10:00", closeTime: "20:00" },
      Friday: { closed: false, openTime: "10:00", closeTime: "20:00" },
      Saturday: { closed: false, openTime: "10:00", closeTime: "20:00" },
    };
    const [errors, setErrors] = useState({});
    const validateCustomUrl = (url, event) => {
        if(url == "") return true;
        // Allow backspace (keyCode 8) and tab (keyCode 9)
        if (event && (event.keyCode === 8 || event.keyCode === 9)) {
            return true;
        }
        
        // Regular expression to validate the custom URL
        const urlRegex = /^[a-zA-Z0-9-]+$/;
        return urlRegex.test(url);
    };

const deliveryCountriesOptions = countryOptions.map((country) => ({
    label: t[l]?.[country.value],//country.label,
    value: country.value,
  }));
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      if (name === "customUrl" && !validateCustomUrl(value)) {
  const please_enter_a_valid_url = t[l]?.please_enter_a_valid_url || "Please enter a valid URL (letters, numbers, hyphens only).";
  console.log('Error:', please_enter_a_valid_url);
        setErrors({ ...errors, [name]: please_enter_a_valid_url});
        return;
    }
      setFormDataList({ ...formDataList, [name]: value });
      if (name == "country" ) {  
        getCitiesApi(value);
      }
      //customUrl
      setErrors({ ...errors, [name]: "" }); // Clear the error on change
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormDataList((prevState) => ({...prevState,[name]: value,}));
    //     if (name == "country") {  
    //       getCitiesApi(value);
    //     }
    //   };
  
    const titleRef = useRef(null);
    const storeNumberRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const statusRef = useRef(null);
    const openingDateRef = useRef(null);
    const countryRef = useRef(null);
    const cityRef = useRef(null);
    const addressRef = useRef(null);
   
    const validateForm = () => {
      const newErrors = {};
      if (!formDataList.title) {newErrors.title = t[l]?.store_name_is_required}
      if (!formDataList.storeNumber) {newErrors.storeNumber = t[l]?.store_code_is_required}
      if (!/\S+@\S+\.\S+/.test(formDataList.email)) {newErrors.email =  t[l]?.invalid_email_format}
      if (!formDataList.email) {newErrors.email = t[l]?.email_is_required}
    //   if(formDataList.phone)
    //     if (!/^\+?\d{5,15}$/.test(formDataList.phone)) {
    //         newErrors.phone =  t[l]?.invalid_phone_number_must_be_between_5_and_15_digits_must_be_number_only;
    //     }
    //   if (!formDataList.phone) {newErrors.phone = t[l]?.phone_is_required}
     console.log('formDataList.status',formDataList.status)
      if (formDataList.status == undefined) {newErrors.status = t[l]?.status_is_required}
      if (!formDataList.openingDate) {newErrors.openingDate =  t[l]?.opening_date_is_required}
      if (!formDataList.country || formDataList.country == "select_country") {newErrors.country = t[l]?.country_is_required}
      if (!formDataList.cityId) {newErrors.cityId = t[l]?.city_is_required}
      if (!formDataList.address) {newErrors.address = t[l]?.address_is_required}
  
      setErrors(newErrors);
      if (!formDataList?.title) {
        titleRef.current.focus();
        return;
    }
    if (!formDataList?.storeNumber) {
        storeNumberRef.current.focus();
        return;
    }
    if (!formDataList?.email) {
        emailRef.current.focus();
        return;
    }
    // if (!formDataList?.phone) {
    //     phoneRef.current.focus();
    //     return;
    // }
    if (formDataList.status == undefined) {
        statusRef.current.focus();
        return;
    }
    if (!formDataList?.openingDate) {
        openingDateRef.current.focus();
        return;
    }
    if (!formDataList?.country) {
        countryRef.current.focus();
        return;
    }
    if (!formDataList?.cityId) {
        cityRef.current.focus();
        return;
    }
    if (!formDataList?.address) {
        addressRef.current.focus();
        return;
    }

      return Object.keys(newErrors).length === 0; // Return true if no errors
    };
   
    if(storeData)
    {
        if(!storeData._id)
        {
            storeData = null;
        }
    }
        
    const [schedule, setSchedule] = useState(initialSchedule);
  
    const storeTypeOPtions = [
      {
        label: "Street Store",
        value: "Street Store",
      },
      {
        label: "Within Facilities",
        value: "Within Facilities",
      },
    ];
    //
  
    const storeStatus = [
      { label: "Operational", value: 0 },
      { label: "Permanently Closed", value: 1 },
    ];
  
    const getCitiesApi = async (countryName) => {
          //  eslint-disable-next-line no-debugger
        const selectedCountryData = citiesData.countries.find(country => country.name === countryName);

        if (selectedCountryData) {
            // Transforming cities to the desired format
            const formattedCities = selectedCountryData.cities.map(city => ({
              label: city,
              value: city,
            }));
            console.log('formattedCities',formattedCities);
            setCities(formattedCities);
          } else {
            setCities([]);
          }
    };
    //
    useEffect(() => {
      const countryName = '';
      getCitiesApi(countryName);
    }, []);

    const goBack = () => {
        getStoreApi(localStorage.getItem("roleTitle"));
        navigate("/store-list")
      }
    useEffect(() => {
        console.log('storeData3',storeData);
    if(storeData)
    {
        const { country } = storeData.locationDetails;

        // Fetch cities for the selected country
        if (country) {
            getCitiesApi(country);
        }
        if (Object.keys(storeData).length) {
            const {
            title,
            storeNumber,
            brands: storeBrand,
            types: storeType,
            status,
            level,
            openDate: openingDate,
            area: storeArea,
            email,
            phone,
            logoUrl,
            coverImageUrl,
            baseRate,
            weightRate,
            distanceRate,
            distance,
            standartPickupTime,
            cityId,
            address,
            storeTimings,
            customUrl,
            deliveryCountries
            } = storeData;
            // reassing timmings
            Object.keys(initialSchedule).forEach((day) => {
            let findX = storeTimings?.find(
                (item) => item.day === day.toLowerCase()
            );
            console.log(findX, "storeTimings");
            if (findX) {
                initialSchedule[day] = {
                closed: false,
                openTime: findX.openingTime,
                closeTime: findX.closingTime,
                };
            } else {
                initialSchedule[day] = {
                closed: true,
                openTime: "10:00",
                closeTime: "20:00",
                };
            }
            });
            setSchedule(initialSchedule);
            //
            const { country } =
            storeData.locationDetails;
            
           
            setFormDataList({
            title,
            storeNumber,
            storeBrand,
            storeType,
            status,
            level,
            openingDate,
            storeArea,
            country,
            
            email,
            phone,
            logoUrl,
            coverImageUrl,
            baseRate,
            weightRate,
            distanceRate,
            distance,
            standartPickupTime,
            cityId,
            address,
            customUrl,
            deliveryCountries
            });
        } else {
            setFormDataList({});
        }
    }
    }, [storeData]);
  
    const submit = async (event) => {
      event.preventDefault();
      
      if (validateForm())
      {
        const payload = {
            // storeId: formDataList.storeId,
            level: formDataList.level,
            title: formDataList.title,
            storeNumber: formDataList.storeNumber,
            // brands: [formDataList.storeBrand],
            types: [formDataList.storeType],
            status: formDataList.status,
            area: formDataList.storeArea,
            openDate: formDataList.openingDate,
            closeDate: formDataList.closingDate,
            cityId: formDataList.cityId,
            address: formDataList.address,

            email: formDataList.email,
            phone: formDataList.phone,
            logoUrl: formDataList.logoUrl,
            coverImageUrl: formDataList.coverImageUrl,
            baseRate: formDataList.baseRate,
            weightRate: formDataList.weightRate,
            distanceRate: formDataList.distanceRate,
            distance: formDataList.distance,
            standartPickupTime: formDataList.standartPickupTime,
            customUrl: formDataList.customUrl,
            deliveryCountries: formDataList.deliveryCountries,
            locationDetails: {
            country: formDataList.country,
            },
        };
        
        if (!formDataList.closeDate) {
            delete payload.closeDate;
        }
        //
        const timings = [];
        Object.entries(schedule).forEach(([day, info]) => {
            if (!info.closed) {
            timings.push({
                day: day?.toLowerCase(),
                openingTime:
                info.openTime.length == 8
                    ? info.openTime.slice(0, 5)
                    : info.openTime,
                closingTime:
                info.closeTime.length == 8
                    ? info.closeTime.slice(0, 5)
                    : info.closeTime,
            });
            }
        });
        payload.storeTimings = timings;
        if (!storeData) {
            setBtnLoading(true);
            try {
            const res = await createStore(payload);
            console.log('Final Result', res)
            if (res) {
            
                setBtnLoading(false);
                MySwal.fire({
                position: "top-end",
                icon: "success",
                title: "Created Successfully!",
                showConfirmButton: false,
                timer: 3000,
                }).then(() => {
                    goBack();
                });
            }
            } catch (error) {
            setBtnLoading(false);
            console.log(error);
            MySwal.fire({
                position: "top-end",
                icon: "error",
                title: error.response.data.message,
                showConfirmButton: false,
                timer: 3000,
            });
            }
        } else {
            setBtnLoading(true);
            payload.storeId = storeData._id;
            payload.brands = formDataList.storeBrand;
            if (!Array.isArray(formDataList.storeType)) {
                payload.types = [formDataList.storeType];
            } else {
                payload.types = formDataList.storeType; // If it's already an array, just assign it
            }
            
            try {
                console.log("updateStore1");
            const res = await updateStore(payload);
            let res2 = null;
            try
            {
                const obj = {
                    storeId: payload.storeId,
                    title: payload.title,
                    storeNumber: payload.storeNumber
                }
                console.log("obj",obj);
                
                res2 = await axios.post('updatestoreinotherdata/', obj);
            }
            catch(e) {
                console.log(e)
                return false;
            }
            if (res && res2) {


                setBtnLoading(false);
                MySwal.fire({
                position: "top-end",
                icon: "success",
                title: "Update Successfully!",
                showConfirmButton: false,
                timer: 3000,
                }).then(() => {
                    goBack();
                });
            }
            } catch (error) {
            setBtnLoading(false);
            console.log(error);
            MySwal.fire({
                position: "top-end",
                icon: "error",
                title: error.response.data.message,
                showConfirmButton: false,
                timer: 3000,
            });
            }
        }
        }
    };
    
    const handleImageUpload = async(event, type) => {
        try {
            if(event.target.files.length) {
                const file = event.target.files[0];
                // Check the file size
                if (file.size > 5242880) {//5mb
                    alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 5 MB limit");
                    event.target.value = ''; // Clear the file input
                    return;
                }

                // Image compression options
                const options = {
                    maxSizeMB: 1, // Adjust the max size as needed
                    maxWidthOrHeight: 500, // Adjust dimensions as needed
                    useWebWorker: true
                };
                // const compressedFile = await imageCompression(file, options);
                let name = await uploadImageNew(file,'store','img');
                event.target.value = '';
                console.log('name',name);
                    
                if (file && file.type.startsWith('image/')) {
                    setFormDataList((prev) => ({
                        ...prev,
                        [type]: name,
                    }));
                } else {
                    alert('Please upload a valid image file.');
                }

            }
        } catch (error) {
            console.error('Error compressing image:', error);
        }
    };

    const handleDrop = async (event, type) => {
        event.preventDefault();

        try {
            if(event.dataTransfer.files.length) {
                const file = event.dataTransfer.files[0];
                // Check the file size
                if (file.size > 5242880) {//5mb
                    alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 5 MB limit");
                    event.target.value = ''; // Clear the file input
                    return;
                }

                // Image compression options
                const options = {
                    maxSizeMB: 1, // Adjust the max size as needed
                    maxWidthOrHeight: 500, // Adjust dimensions as needed
                    useWebWorker: true
                };
                // const compressedFile = await imageCompression(file, options);
                let name = await uploadImageNew(file,'store','img');
                event.target.value = '';
                console.log('name',name);
                    
                if (file && file.type.startsWith('image/')) {
                    setFormDataList((prev) => ({
                        ...prev,
                        [type]: name,
                    }));
                } else {
                    alert('Please upload a valid image file.');
                }

            }
        } catch (error) {
            console.error('Error compressing image:', error);
        }
    };

    const renderImagePreview = (type) => {
        //bucketObj.bucketUrl+bucketObj.objectKey+imageData
        if (formDataList[type]) {
            if(formDataList[type] == "deleted")
            {
                return null;
            }
            var imageUrl = "";
            if(type == 'logoUrl')
                imageUrl = bucketObj.bucketUrl+bucketObj.objectKey+formDataList.logoUrl;//URL.createObjectURL(formDataList[type]);
            else
                imageUrl = bucketObj.bucketUrl+bucketObj.objectKey+formDataList.coverImageUrl;//URL.createObjectURL(formDataList[type]);
            
            return (
                <>
                <img
                    src={imageUrl}
                    alt={type}
                    className="img-fluid-phone-img"
                    // className="img-fluid"
                    style={{ maxWidth: "100%",maxHeight: "80%" }}
                />
                <button
                type="button"
                className="btn btn-danger position-absolute"
                style={{
                    top: 'calc(37% - 15px)', // Adjusts position based on image height
                    right: 'calc(11% - 15px)', // Adjusts position based on image width
                  borderRadius: '50%',
                  width: '17px',
                  height: '17px',
                  padding: '0',
                  lineHeight: '1',
                  zIndex: 10, // Ensure it's on top of the image
                }}

                onClick={(e) => {
                  e.stopPropagation(); // Prevent click from bubbling up
                  setFormDataList((prev) => ({
                    ...prev,
                    [type]: "deleted",
                }));
                
                }}
              >
                &times; {/* Cross symbol */}
              </button>
              </>
            );
        }
        return null;
    };

    // const handleInputChange = (e) => {
    //   const { name, value } = e.target;
    //   setFormDataList((prevState) => ({
    //     ...prevState,
    //     [name]: value,
    //   }));
    //   if (name == "country") {  
    //     getCitiesApi(value);
    //   }
    // };
    const handleCheckboxChange = (day) => {
      setSchedule((prev) => ({
        ...prev,
        [day]: { ...prev[day], closed: !prev[day].closed },
      }));
    };
  
    const handleTimeChange = (day, type, value) => {
      setSchedule((prev) => ({
        ...prev,
        [day]: { ...prev[day], [type]: value },
      }));
    };
    return (
      <>
     
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                        <h4>{t?.[l]?.["new_store"] || "New Store"}</h4>
                        <h6>{t?.[l]?.["addstore"] || "Add Store"}</h6>
                        </div>
                    </div>
                    </div>
                    <form onSubmit={submit}>
                        <div className="card">
                            <div className="card-body add-product pb-0">
                                <div
                                    className="accordion-card-one accordion"
                                    id="accordionExample"
                                >
                                    <div className="accordion-item">
                                        <div className="accordion-header" id="headingOne">
                                        <div
                                            className="accordion-button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-controls="collapseOne"
                                        >
                                            <div className="addproduct-icon">
                                            <h5>
                                                <Info className="add-info" />
                                                <span>{t?.[l]?.["store_information"] || "Store Information"}</span>
                                            </h5>
                                   
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">

                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-lg-6 pe-0">
                                                        <div className="mb-3">
                                                            <label   className="form-label">{t?.[l]?.["store_name"]}*</label>
                                                            <input
                                                               ref={titleRef}
                                                                type="text"
                                                                placeholder={t?.[l]?.["store_name"]}
                                                                className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                                                                value={formDataList.title || ""}
                                                                name="title"
                                                                maxLength={100}
                                                                onChange={handleInputChange}
                                                            />
                                                            {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                                                        </div>

                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                            <div className="mb-3">
                                                                <label className="form-label">{t?.[l]?.["store_code"]}*</label>
                                                                <input
                                                                    ref={storeNumberRef}
                                                                    type="text"
                                                                    placeholder={t?.[l]?.["store_code"]}
                                                                    className={`form-control ${errors.storeNumber ? 'is-invalid' : ''}`}
                                                                    value={formDataList.storeNumber || ""}
                                                                    name="storeNumber"
                                                                    maxLength={20}
                                                                    onChange={handleInputChange}
                                                                />
                                                                {errors.storeNumber && <div className="invalid-feedback">{errors.storeNumber}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 pe-0">
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    {t?.[l]?.["custom_url"] || "Custom Url"}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder= {t?.[l]?.["custom_url"] || "Custom Url"}	 
                                                                    className={`form-control ${errors.customUrl ? 'is-invalid' : ''}`}
                                                                    value={formDataList?.customUrl || ""}
                                                                    name="customUrl"  
                                                                    maxLength={50}
                                                                    onChange={handleInputChange}
                                                                />
                                                                {formDataList?.customUrl && (
                                                                    <small>
                                                                         {t?.[l]?.["preview"] || "Preview"}: <b>
                                                                        {getUrls().ecomUrl}store/{formDataList.customUrl}</b>
                                                                    </small>
                                                                )}
                                                                 {errors.customUrl && <div className="invalid-feedback">{errors.customUrl}</div>}
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 pe-0">
                                                            <div className="mb-3">
                                                                <label className="form-label">{t?.[l]?.["email"] || "Email"}*</label>
                                                                <input
                                                                ref={emailRef}
                                                                    type="text"
                                                                    placeholder={t?.[l]?.["email"] || "Email"}
                                                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                                    value={formDataList.email || ""}
                                                                    name="email"
                                                                    maxLength={50}
                                                                    onChange={handleInputChange}
                                                                />
                                                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                            <div className="mb-3">
                                                                <label className="form-label">{t?.[l]?.["phone"] || "Phone"}</label>
                                                                <input
                                                                 ref={phoneRef}
                                                                    type="text"
                                                                    placeholder={t?.[l]?.["phone"] || "Phone"}
                                                                    className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                                                    value={formDataList.phone || ""}
                                                                    name="phone"
                                                                    maxLength={15}
                                                                    onChange={handleInputChange}
                                                                />
                                                                {/* {errors.phone && <div className="invalid-feedback">{errors.phone}</div>} */}
                                                            </div>
                                                        </div>
                                                    
                                                        <div className="col-lg-6 pe-0">
                                                        <div className="mb-3">
                                                            <label name="storeType" className="form-label">
                                                            {t?.[l]?.["store_type"]}
                                                            </label>
                                                            <Select
                                                            className="select"
                                                            options={storeTypeOPtions}
                                                            value={
                                                                storeTypeOPtions.find(
                                                                (option) =>
                                                                    option.value ===
                                                                    formDataList?.storeType?.toString()
                                                                ) || "defalut"
                                                            }
                                                            name="storeType"
                                                            onChange={(v) => {
                                                                handleInputChange({
                                                                target: { name: "storeType", value: v.value },
                                                                });
                                                            }}
                                                            disabled={true}
                                                            />
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                        {/* <div className="mb-3">
                                                            <label name="status" className="form-label">
                                                            {t?.[l]?.["status"]}*
                                                            </label>
                                                            <Select
                                                            required
                                                            className="select"
                                                            options={storeStatus}
                                                            value={storeStatus.find(
                                                                (option) => option.value == formDataList?.status
                                                            ) || ""}
                                                            name="status"
                                                            onChange={(v) => {
                                                                handleInputChange({
                                                                target: { name: "status", value: v.value },
                                                                });
                                                            }}
                                                            />
                                                        </div> */}
                                                        <div className="mb-3">
                                                        <label name="status" className="form-label">{t?.[l]?.["status"]}*</label>
                                                        <Select
                                                           ref={statusRef}
                                                            className={`select ${errors.status ? 'is-invalid' : ''}`}
                                                            options={storeStatus}
                                                            value={storeStatus.find(option => option.value === formDataList.status) || ""}
                                                            name="status"
                                                            onChange={(v) => handleInputChange({ target: { name: "status", value: v.value } })}
                                                        />
                                                        {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                                                        </div>

                                                        </div>
                                                        
                                                        <div className="col-lg-6 pe-0">
                                                        {/* <div className="mb-3">
                                                            <label className="form-label">
                                                            {t?.[l]?.["opening_date"]}*
                                                            </label>
                                                            <input
                                                            required
                                                            id="startDate"
                                                            className="form-control"
                                                            type="date"
                                                            value={formDataList?.openingDate || ""}
                                                            name="openingDate"
                                                            onChange={handleInputChange}
                                                            />
                                                        </div> */}
                                                        <div className="mb-3">
                                                        <label className="form-label">{t?.[l]?.["opening_date"]}*</label>
                                                        <input
                                                            ref={openingDateRef}
                                                            type="date"
                                                            className={`form-control ${errors.openingDate ? 'is-invalid' : ''}`}
                                                            value={formDataList.openingDate || ""}
                                                            name="openingDate"
                                                            onChange={handleInputChange}
                                                        />
                                                        {errors.openingDate && <div className="invalid-feedback">{errors.openingDate}</div>}
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                        <div className="mb-3">
                                                            <label className="form-label">{t?.[l]?.["closing_date"]}</label>
                                                            <input
                                                            disabled={!formDataList?.status}
                                                            id="startDate"
                                                            className="form-control"
                                                            type="date"
                                                            value={formDataList?.closingDate || ""}
                                                            name="closingDate"
                                                            onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                        <div className="mb-3">
                                                            <label className="form-label">{t?.[l]?.["floor_level"]}</label>
                                                            <input
                                                            type="number"
                                                            placeholder={t?.[l]?.["floor_level"]}
                                                            className="form-control"
                                                            value={formDataList?.level || ""}
                                                            name="level"
                                                            onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                        <div className="mb-3">
                                                            <label className="form-label">{t?.[l]?.["store_area"] || "Store Area"}</label>
                                                            <input
                                                            placeholder={t?.[l]?.["store_area"] || "Store Area"}
                                                            className="form-control form-control-lg group_formcontrol pl-4"
                                                            value={formDataList?.storeArea || ""}
                                                            name="storeArea"
                                                            onChange={handleInputChange}
                                                            type="text"
                                                            maxLength={20}
                                                            />
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                        {/* <div className="mb-3">
                                                            <label name="country" className="form-label">
                                                            {t?.[l]?.["country"]} *
                                                            </label>
                                                            <Select
                                                            required
                                                            className="select"
                                                            options={countryOptions}
                                                            value={countryOptions.find(
                                                                (option) => option.value === formDataList?.country
                                                            )}
                                                            name="country"
                                                            onChange={(v) => {
                                                                handleInputChange({
                                                                target: { name: "country", value: v.value },
                                                                });
                                                            }}
                                                            />
                                                        </div> */}
                                                        <div className="mb-3">
                                                        <label name="country" className="form-label">{t?.[l]?.["country"]} *</label>
                                                        <Select
                                                            ref={countryRef}
                                                            className={`select ${errors.country ? 'is-invalid' : ''}`}
                                                            options={countryOptions}
                                                            value={countryOptions.find(option => option.value === formDataList.country)}
                                                            name="country"
                                                            onChange={(v) => handleInputChange({ target: { name: "country", value: v.value } })}
                                                        />
                                                        {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-6 pe-0">
                                                        {/* <div className="mb-3">
                                                            <label name="city" className="form-label">
                                                            {t?.[l]?.["city"]} *
                                                            </label>
                                                            <Select
                                                            required
                                                            className="select"
                                                            options={cities}
                                                            value={cities?.find(
                                                                (option) => option.value === formDataList?.cityId
                                                            ) || ""}
                                                            name="cityId"
                                                            onChange={(v) => {
                                                                handleInputChange({
                                                                target: { name: "cityId", value: v.value },
                                                                });
                                                            }}
                                                            disabled={!formDataList?.prefecture}
                                                            />
                                                        </div> */}
                                                        <div className="mb-3">
                                                        <label name="city" className="form-label">{t?.[l]?.["city"]} *</label>
                                                        <Select
                                                            ref={cityRef}
                                                            className={`select ${errors.cityId ? 'is-invalid' : ''}`}
                                                            options={cities}
                                                            value={cities.find(option => option.value === formDataList.cityId) || ""}
                                                            name="cityId"
                                                            onChange={(v) => handleInputChange({ target: { name: "cityId", value: v.value } })}
                                                            disabled={!formDataList.prefecture}
                                                        />
                                                        {errors.cityId && <div className="invalid-feedback">{errors.cityId}</div>}
                                                        </div>
                                                        </div>
                                                        <div className="col-lg-12 pe-0">
                                                            {/* <div className="mb-3">
                                                                <label className="form-label">{t?.[l]?.["address"]}*</label>
                                                                <input
                                                                type="text"
                                                                required
                                                                className="form-control"
                                                                value={formDataList?.address || ""}
                                                                name="address"
                                                                onChange={handleInputChange}
                                                                />
                                                            </div> */}
                                                             <div className="mb-3">
                                                            <label className="form-label">{t?.[l]?.["address"]}*</label>
                                                            <input
                                                                placeholder={t?.[l]?.["address"]}
                                                                ref={addressRef}
                                                                type="text"
                                                                className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                                                value={formDataList.address || ""}
                                                                name="address"
                                                                onChange={handleInputChange}
                                                                maxLength={1000}
                                                            />
                                                            {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                                                            </div>
                                                        </div>
                                                    </div>   
                                                </div>
                                              
                                                <div className="col-lg-4">
                                                    {/* Image upload section with drag and drop */}
                                                    <div className="row">
                                                        <div className="col-12 mb-3">
                                                            <label className="form-label">{t?.[l]?.["upload_logo"] || "Upload Logo"}</label>
                                                            <div
                                                                className="image-upload p-4 text-center position-relative"
                                                                onDragOver={(e) => e.preventDefault()}
                                                                onDrop={(e) => handleDrop(e, 'logoUrl')}
                                                                onClick={() => document.getElementById('logoInput').click()}
                                                                style={{ height: '200px' }} // Set height for the logo box
                                                            >
                                                                
                                                                <input
                                                                    id="logoInput"
                                                                    type="file"
                                                                    className="d-none"
                                                                    accept="image/*"
                                                                    onChange={(e) => handleImageUpload(e, 'logoUrl')}
                                                                />
                                                                <p>{t?.[l]?.["drag_&_drop_or_click_to_upload"] || "Drag & drop or click to upload"}</p>
                                                                {renderImagePreview('logoUrl')}
                                                                </div>
                                                        </div>
                                                        <div className="col-12 mb-3">
                                                            <label className="form-label">{t?.[l]?.["upload_cover"] || "Upload Cover"}</label>
                                                            <div
                                                                className="image-upload p-4 text-center position-relative"
                                                                onDragOver={(e) => e.preventDefault()}
                                                                onDrop={(e) => handleDrop(e, 'coverImageUrl')}
                                                                onClick={() => document.getElementById('coverInput').click()}
                                                                style={{ height: '200px' }} // Set height for the cover box
                                                            >
                                                                <input
                                                                    id="coverInput"
                                                                    type="file"
                                                                    className="d-none"
                                                                    accept="image/*"
                                                                    onChange={(e) => handleImageUpload(e, 'coverImageUrl')}
                                                                />
                                                                <p>{t?.[l]?.["drag_&_drop_or_click_to_upload"] || "Drag & drop or click to upload"}</p>
                                                                {renderImagePreview('coverImageUrl')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-header" id="headingOne">
                                                <div className="accordion-button">
                                                    <div className="addproduct-icon">
                                                        <h5><Info className="add-info" /><span>{t?.[l]?.["shipping_details"] || "Shipping Details"}</span></h5>
                                                    </div>
                                                </div>
                                            </div>
                                          
                                                <div className="col-lg-6 pe-0">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                        {t?.[l]?.["base_rate"]}
                                                        </label>
                                                        <input
                                                        type="text"
                                                        placeholder={t?.[l]?.["base_rate"]}
                                                        className="form-control"
                                                        value={formDataList?.baseRate || ""}
                                                        name="baseRate"
                                                      
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === "" || /^-?\d*(\.\d*)?$/.test(value)) {
                                                              handleInputChange(e);
                                                            }
                                                          }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 pe-0">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                        {t?.[l]?.["weight_rate"]}
                                                        </label>
                                                        <input
                                                        type="text"
                                                        placeholder={t?.[l]?.["weight_rate"]}
                                                        className="form-control"
                                                        value={formDataList?.weightRate || ""}
                                                        name="weightRate"
                                                        // onChange={handleInputChange}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === "" || /^-?\d*(\.\d*)?$/.test(value)) {
                                                              handleInputChange(e);
                                                            }
                                                          }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 pe-0">
                                                  
                                                    <div className="mb-3">
                                                        <label className="form-label">  {t?.[l]?.["delivery_to"] || "Delivery to"}:</label>
                                                        <Select
                                                            className="select"
                                                            options={deliveryCountriesOptions}
                                                            isMulti // Enable multi-select
                                                            value={deliveryCountriesOptions.filter(option =>
                                                                formDataList.deliveryCountries?.includes(option.value)
                                                            )}
                                                            name="deliveryCountries"
                                                            onChange={(selectedOptions) =>
                                                                handleInputChange({
                                                                    target: { name: "deliveryCountries", value: selectedOptions.map(option => option.value) }
                                                                })
                                                            }
                                                        />
                                                    </div>
                                        
                                                </div>
                                               
                                        <div className="accordion-header" id="headingOne">
                                            <div className="accordion-button">
                                                <div className="addproduct-icon">
                                                    <h5><Info className="add-info" /><span>{t?.[l]?.["store_timings"] || "Store Timings"}</span></h5>
                                                </div>
                                            </div>
                                        </div>
                                            <div className="row">
                                                <div className="col-lg-6 pe-0">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                        {t?.[l]?.["standard_pickup_time"]}
                                                        </label>
                                                        <input
                                                        type="text"
                                                        placeholder={t?.[l]?.["standard_pickup_time"]}
                                                        className="form-control"
                                                        value={formDataList?.standartPickupTime || ""}
                                                        name="standartPickupTime"
                                                        onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                            <div className="mb-3 input-blocks">
                                                <label className="form-label">{t?.[l]?.["store_hours"]}</label>
                                                <div className="table-responsive">
                                                <table className="table table-borderless mb-0">
                                                    <thead>
                                                    <tr>
                                                        <th>{t?.[l]?.["day"]}</th>
                                                        <th>{t?.[l]?.["closed"]}</th>
                                                        <th>{t?.[l]?.["open_hours"]}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {Object.keys(schedule).map((day) => (
                                                        <tr key={day}>
                                                        <td>{day}</td>
                                                        
                                                        <td>
                                                           
                                                             <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    checked={schedule[day].closed}
                                                                    onChange={() => handleCheckboxChange(day)}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className="d-flex align-item-center ">
                                                            <input
                                                                id="time"
                                                                className="form-control m-1"
                                                                type="time"
                                                                value={schedule[day].openTime}
                                                                onChange={(e) =>
                                                                handleTimeChange(
                                                                    day,
                                                                    "openTime",
                                                                    e.target.value
                                                                )
                                                                }
                                                                disabled={schedule[day].closed}
                                                            />
                                                            <input
                                                                id="time"
                                                                className="form-control m-1"
                                                                type="time"
                                                                value={schedule[day].closeTime}
                                                                onChange={(e) =>
                                                                handleTimeChange(
                                                                    day,
                                                                    "closeTime",
                                                                    e.target.value
                                                                )
                                                                }
                                                                disabled={schedule[day].closed}
                                                            />
                                                            </span>
                                                        </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>   
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="btn-addproduct mb-4">
                            <button type="button" className="btn btn-cancel me-2" onClick={goBack}>
                                {t?.[l]?.["cancel"] || "Cancel"}
                            </button>
                            <button type="submit" className="btn btn-submit">
                            {t[l]?.[btnLoading ? "wait" : "save"] || [btnLoading ? "Wait..." : "Save"]}
                            </button>
                            </div>
                        </div>
                    {/* {btnLoading ? "Wait..." : "Save"} */}


                     
                    </form> 
                </div>
            </div> 
      </>
    );
  };
  

export default AddStore;